"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const styles = (0, _makeStyles.default)(theme => ({
  "@keyframes showHint": {
    "0%": {
      opacity: 1,
      transform: "translate(-50%,24px)"
    },
    "50%": {
      opacity: 1,
      transform: "translate(-50%,32px)"
    },
    "100%": {
      opacity: 1,
      transform: "translate(-50%,24px)"
    }
  },
  iconButton: {
    alignItems: "center",
    borderRadius: 48,
    border: "1px solid " + theme.palette.text.secondary,
    color: theme.palette.text.secondary,
    cursor: "pointer",
    fontSize: 16,
    display: "flex",
    letterSpacing: "1.6px",
    fontWeight: 700,
    gap: theme.spacing(1.5),
    height: 48,
    minWidth: 176,
    padding: theme.spacing(1, 3),
    position: "relative"
  },
  dateHint: {
    background: theme.palette.primary.main,
    borderRadius: 12,
    color: "#FFFFFF",
    fontFamily: "'Bree Serif'",
    fontSize: 20,
    padding: 16,
    left: "50%",
    opacity: 0,
    lineHeight: "normal",
    position: "absolute",
    textAlign: "center",
    top: "100%",
    pointerEvents: "none",
    transform: "translate(-50%, 24px)",
    transition: "all 1s ease",
    width: 180,
    "&:before": {
      background: theme.palette.primary.main,
      content: "''",
      height: 20,
      left: "50%",
      marginLeft: -10,
      position: "absolute",
      transform: "rotate(-45deg)",
      top: -10,
      width: 20
    }
  },
  dateHintShow: {
    animation: "$showHint 2s infinite"
  }
}));
var _default = exports.default = styles;